// extracted by mini-css-extract-plugin
export default {"scatter":"DeepDive_scatter__TTDVr","content":"DeepDive_content__svar1","chartWrapper":"DeepDive_chartWrapper__nBCBi","chartTitle":"DeepDive_chartTitle__gRwnS"};